function Header() {
  return (
    <div className="w-full px-6 py-3 flex flex-row shadow-md text-gray-500">
      <div className="pr-12">
        <img
          className="w-20 md:w-24"
          src="./lookie_logo_text.png"
          alt="logo"
        ></img>
      </div>
      <div className="flex flex-row items-center gap-4 lg:gap-6">
        <a className="hover:text-main" href="/">
          首頁
        </a>
        <div className="h-5 border-r border-gray-200"></div>
        <a
          className="hover:text-main"
          href="https://www.two-tool.com.tw"
          target="_blank"
          rel="noreferrer"
        >
          拓圖科技
        </a>
        <div className="h-5 border-r border-gray-200"></div>
        <a
          className="hover:text-main"
          href="https://page.line.me/?accountId=twotool"
          target="_blank"
          rel="noreferrer"
        >
          聯絡我們
        </a>
      </div>
    </div>
  );
}

export default Header;
